export default __webpack_public_path__ + "static/2-4513e694f08e8c2e09c9d65834984c83.png";